module.exports = __webpack_public_path__ + "img/il-logo-primary.9dad62ce.png";